/*
 * PDP Stats Grid — sound toggle binding (Phase 3b)
 *
 * Wires the mute/unmute button next to the autoplaying vertical video.
 * Each .pdp-stats root is bound once (idempotent via data-bound).
 * Re-binds in the theme editor when the section reloads.
 */
(function () {
  'use strict';

  function init(root) {
    var btn = root.querySelector('[data-pdp-stats-sound]');
    var video = root.querySelector('.pdp-stats__video video');
    if (!btn || !video || btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', function () {
      var unmuting = video.muted;
      video.muted = !video.muted;
      btn.setAttribute('aria-pressed', String(unmuting));
      btn.setAttribute('aria-label', unmuting ? 'Mute video' : 'Unmute video');
      root.classList.toggle('pdp-stats--unmuted', unmuting);
      if (unmuting) {
        // First unmute: restart from the beginning so the user hears the
        // audio from the top rather than mid-loop. Subsequent unmutes
        // resume in place.
        if (video.dataset.heard !== '1') {
          video.dataset.heard = '1';
          try { video.currentTime = 0; } catch (e) {}
        }
        var play = video.play();
        if (play && typeof play.catch === 'function') play.catch(function () {});
      }
    });
  }

  function run() {
    var nodes = document.querySelectorAll('.pdp-stats');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
